/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createReducer, on } from '@ngrx/store';
import * as AviDataGridStoreActions from './avi-data-grid-store.actions';
import { IAviDataGridState, initialState } from './avi-data-grid-store.state';

export const aviDataGridStoreReducer = createReducer(
    initialState,
    on(
        AviDataGridStoreActions.saveAviDataGridDisplayedColumnsSelection,
        (
            state: IAviDataGridState,
            { currentGridColumnVisibilityState },
        ): IAviDataGridState => ({
            ...state,
            ...currentGridColumnVisibilityState,
        }),
    ),
);
